<template>
  <div id="app">
    <div
      class="d-flex justify-content-center update-overlay"
      style="align-items: center;"
      v-if="updateInstalled"
    >
      <div class="text-center">
        <h1>Update Successful</h1>
        <img
          src="./assets/tick-circle.svg"
          alt="Check Mark"
          style="width: 100px;"
        />
      </div>
    </div>
    <div
      v-if="updateChecker"
      class="d-flex justify-content-center update-overlay"
      style="align-items: center;"
    >
      <div class="text-center">
        <h1>Update Available</h1>
        <p>Before continuing, a quick app update is need</p>
        <button @click="unregisterServiceWorker" class="btn btn-secondary">
          Allow update
        </button>
      </div>
    </div>
    <navigation :online="offlineData" :auth="isloggedIn">
      <desktop-menu @logout="logout"></desktop-menu>
      <mobile-menu
        @showLoader="showLoader"
        :menuShown="menuShown"
        @logout="logout"
      ></mobile-menu>
    </navigation>
    <b-container fluid="sm" @click="hideMenu">
      <b-row>
        <b-col cols="11" class="b-avatar-img mb-3">
          <!--          <img alt="Vue logo" src="./assets/tim-blinks2.gif"  />-->
        </b-col>
        <b-col cols="12">
          <b-alert
            class="text-center"
            show
            variant="warning"
            v-if="!isloggedIn && $route.name !== 'login'"
          >
            <b-icon icon="exclamation-circle"></b-icon>
            To view, export and back up your trips,<router-link
              :to="{ name: 'login' }"
              class="font-weight-bold"
              tag="span"
            >
              log in here
            </router-link>
          </b-alert>
          <b-alert
            show
            variant="warning"
            v-if="!showPlaceBanner && !$route.name === 'new-place'"
          >
            We have added a place called 'Home' for you. Please add more places,
            such as 'Work' etc, to begin using the logbook.
            <b-button
              class="mt-1 btn btn-secondary text-white pr-5 pl-5 tt-border-radius"
              :to="{ name: 'new-place' }"
            >
              Add places
            </b-button>
          </b-alert>
          <!--          <button @click="$stores.commit('syncRecords')">sync</button>-->
        </b-col>
      </b-row>

      <transition name="slide-fade" id="top">
        <router-view
          :defaultVehicle="defaultVehicle"
          :key="newTripComp"
          @reRenderComp="updateCompKeyForRerendering"
        ></router-view>
      </transition>
      <div style="margin-bottom: 50px"></div>
      <div class="text-center mb-5 d-flex justify-content-center">
        <span v-if="!updateChecker" class="mb-5 text-disable py-2 pr-2">
          Latest
        </span>
        <span class="mb-5 text-disable py-2 pr-2">Version 1.6.3</span>
        <div v-if="updateChecker">
          <button
            @click="unregisterServiceWorker"
            class="btn btn-primary text-white"
          >
            Update available
          </button>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Bugsnag from "@bugsnag/js";
import moment from "moment";
import Navigation from "./components/partials/Navigation";
import DesktopMenu from "./components/partials/DesktopMenu";
import MobileMenu from "./components/partials/MobileMenu";
import { mapGetters, mapState } from "vuex";
import { store } from "./store";
import axios from "axios";
import { register } from "register-service-worker";

export default {
  name: "App",
  components: {
    Navigation,
    DesktopMenu,
    MobileMenu
  },

  data() {
    return {
      newTripComp: 0,
      offlineData: false,
      name: "",
      form: {
        _id: new Date().toISOString(),
        from: "",
        to: "",
        distance: "",
        synced: false
      },
      state: Navigator.onLine,
      items: "",
      menuShown: false,
      showPlaceBanner: false,
      updateChecker: false,
      updateInstalled: false
    };
  },

  props: {
    msg: String
  },
  mounted() {
    store.commit("getAllRecord");
  },
  created() {
    //checking for App update
    this.updateInstalled = !!localStorage.getItem("updateInstalled");
    if (process.env.NODE_ENV === "production") {
      var vm = this;
      register(`${process.env.BASE_URL}service-worker.js`, {
        updated() {
          vm.updateChecker = true;
          console.log("New content has been installed; please refresh.");
        }
      });
    }

    this.interceptAxiosRequest();
    //set db index;
    this.$store.state.database.createIndex({
      index: { fields: ["type", "_id", "is_synced"] }
    });

    //get default values
    this.$store.commit("initApp");

    //get last synced
    this.$store.commit("sync/getLastSyncedTime");

    //when deleting s record from pouchdb
    this.$root.$on("deleteRecord", (id, type) => {
      this.$store.dispatch("deleteRecordAction", {
        id: id,
        types: Array(type)
      });
      this.clearMes();
    });

    //sidemenu toggle
    this.$root.$on("sideMenuIsVisible", () => {
      this.menuShown = true;
    });

    this.$root.$on("newRecordSaved", () => {
      console.log("getUnsyncedRecords");
      // this.offlineData = true;
      store.commit("sync/getUnsyncedRecords");
    });

    setInterval(() => {
      if (!this.isloggedIn) {
        this.$store.dispatch("auth/checkAuthAction");
      }
    }, 10000);

    setTimeout(() => {
      if (localStorage.getItem("updateInstalled")) {
        this.updateInstalled = false;
        localStorage.removeItem("updateInstalled");
      }
    }, 3000);
    store.commit("sync/getUnsyncedRecords");

    Bugsnag.notify(new Error("Test error"));
  },
  methods: {
    updateCompKeyForRerendering: function() {
      this.newTripComp += 1;
    },
    hideMenu: function() {
      this.menuShown = false;
    },
    showLoader: function(args) {
      this.loader = args[0];
      this.loadingMessage = args[1];
    },
    interceptAxiosRequest: function() {
      axios.interceptors.request.use(
        config => {
          this.$store.commit("loading", true);
          return config;
        },
        error => {
          this.$store.commit("loading", false);
          return Promise.reject(error);
        }
      );

      axios.interceptors.response.use(
        response => {
          this.$store.commit("loading", false);
          return response;
        },
        error => {
          this.$store.commit("loading", false);
          return Promise.reject(error);
        }
      );
    },
    unregisterServiceWorker: function() {
      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
        localStorage.setItem("updateInstalled", "true");
        document.location.reload();
      });
    },
    logout: function() {
      this.$store.commit("auth/logout");
      document.location.reload();
    }
  },
  computed: {
    ...mapState({
      isloggedIn: state => state.auth.isAuth,
      defaultVehicle: state => state.car.defaultVehicle,
      allTrips: state => state.trip.all,
      lastSyncedTime: state => state.sync.lastSyncedTime ?? {},
      unSyncedRecords: state => state.sync.allUnsyncedRecords,
      hardRefresh: state => state.auth.hardRefresh
    }),
    ...mapGetters({
      doesNotHaveSavedPlace: "place/checkIfPlaceWasAdded",
      allRecords: "allRecords",
      authToken: "auth/getToken"
      // unSyncedRecords: "sync/getAllUnsyncedRecords"
    })
  },

  watch: {
    unSyncedRecords(value) {
      if (value.length > 0 && this.isloggedIn) {
        setTimeout(() => {
          if (window.navigator.onLine) {
            this.$store.dispatch("sync/syncAllDataAction");
            // this.offlineData = false;
            console.log("Called offline data");
            console.log(value);
          }
        }, 5000);
      }
    },
    doesNotHaveSavedPlace(val) {
      if (val) {
        this.showPlaceBanner = true;
      }
    },
    lastSyncedTime(val) {
      moment(val.time).format("d-m-Y");
    },
    hardRefresh(val) {
      console.log("authToken");
      if (val) {
        console.log("authToken 2");
        store.commit("auth/logout");
        store.commit("getAllRecord");
        document.location.reload();
      }
    }
  }
};
</script>

<style lang="scss">
$primary: #54d387;
$danger: red;
$secondary: #41c1d0;
// Import Bootstrap and BootstrapVue source SCSS files
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";

@import "~animate.css";
@import "custom";

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(20px);
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s ease-in;
}
.dropdown-item {
  color: #fff;
}
.dropdown-item:hover {
  background-color: transparent;
}

.update-overlay {
  position: fixed; /* Sit on top of the page content */
  display: block; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(
    255,
    255,
    255,
    0.96
  ); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
